module.exports = __webpack_public_path__ + "static/media/loyalty_prog.d48c36b8.png";